export default __webpack_public_path__ + "static/media/facebook-square-brands.a878bc5c.svg";